var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRoundAddIcCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 12.6667H25.3333V15.8333C25.3333 16.7042 26.0458 17.4167 26.9167 17.4167C27.7875 17.4167 28.5 16.7042 28.5 15.8333V12.6667H31.6667C32.5375 12.6667 33.25 11.9542 33.25 11.0833C33.25 10.2125 32.5375 9.5 31.6667 9.5H28.5V6.33333C28.5 5.4625 27.7875 4.75 26.9167 4.75C26.0458 4.75 25.3333 5.4625 25.3333 6.33333V9.5H22.1667C21.2958 9.5 20.5833 10.2125 20.5833 11.0833C20.5833 11.9542 21.2958 12.6667 22.1667 12.6667ZM30.4158 24.1775L26.3942 23.7183C25.9213 23.6628 25.442 23.7151 24.9922 23.8715C24.5425 24.0278 24.134 24.284 23.7975 24.6208L20.8842 27.5342C16.3894 25.2482 12.736 21.5948 10.45 17.1L13.3792 14.1708C14.06 13.49 14.3925 12.5242 14.2817 11.5742L13.8225 7.58417C13.737 6.81149 13.3702 6.09726 12.7921 5.57753C12.214 5.0578 11.4649 4.76889 10.6875 4.76583H7.94833C6.15916 4.76583 4.67083 6.25417 4.78166 8.04333C5.62083 21.565 16.435 32.3633 29.9408 33.2025C31.73 33.3133 33.2183 31.825 33.2183 30.0358V27.2967C33.2342 25.7133 32.015 24.3517 30.4158 24.1775V24.1775Z",
    fill: "#AA9767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundAddIcCall);
export default __webpack_public_path__ + "static/media/ic_round-add-ic-call.1f9cb2f55cb437570fba21fa3ccd7cbc.svg";
export { ForwardRef as ReactComponent };